import styled from 'styled-components';
import { MenuIcon, device, Container } from '../../mediaQuery';

export const NavbarContainer = styled.div`
	background-color: var(--colorBlack);
	width: 100%;
	height: 100px;
	position: sticky;
	top: 0;
	z-index: 100;

	@media ${device.tablet} {
		position: relative;
	}
`;

export const ContentContainer = styled(Container)`
	width: inherit;
	display: flex;
	justify-content: center;
	align-items: center;
	height: inherit;

	.nav-company-logo {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: var(--fontS);
		text-transform: uppercase;
		text-decoration: none;
		color: var(--colorWhite)
	}

	@media ${device.tablet} {
		justify-content: space-between;
	
	}

`;

export const NavbarUl = styled.ul`
	display: none;

	@media ${device.tablet} {
		width: 600px;
		display: flex;
		flex-direction: row;
		justify-content: space-around;
		align-items: center;
		padding-left: 25px;
		font-size: var(--fontS);
		font-weight: var(--fontBold);
	}
`;

export const NavbarLi = styled.li`
	display: flex;
	align-items: center;
	list-style: none;
	line-height: 50px;
	letter-spacing: 1px;

	a {
		color: var(--colorWhite);
		text-decoration: none;
	}

	a:hover {
		color: var(--colorRed);
	}
`;
export const Icon = styled(MenuIcon)`
	@media ${device.tablet} {
		display: none;
	}
`;

export const Logo = styled.img`
	margin: 0 auto;
	width: 100px;
	height: 100px;

	@media ${device.tablet} {
		margin: 0;
		width: 150px;
		height: 150px;
	}
`;
